import {Avatar, Input} from 'antd'
import classNames from 'classnames'
import {AppTextLogoIcon} from 'components/icons/AppTextLogoIcon'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {LoginContext} from 'components/LoginContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useRef, useState} from 'react'
import {RiSearch2Line, RiUser2Fill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {useClickAway, useLocation, useToggle} from 'react-use'
import {withProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {HeaderButton} from 'views/Organization/components/PageHeader'
import {SearchTypes} from 'views/Search/SearchProvider'
import {NullAsDefault, renderSelf,} from 'views/Shared'
import {useDrawerDetector} from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import HeaderNavigation from './HeaderNavigation'
import {ANDROID_PLAY_LINK, APPLE_ITUNES_LINK, IS_CORDOVA} from "../../envs/_current/config";
import {BsPersonCircle} from "react-icons/bs";
import {TbMenu2} from "react-icons/tb";
import GoBackAction from "../AppLocals/custom/GoBackAction";
import UpdateBanner from "./UpdateBanner";
import {GoHomeFill} from "react-icons/go";
import {HiMiniUserGroup} from "react-icons/hi2";
import {isIOS} from "../../envs/environment";
import {MdClose, MdNewspaper} from "react-icons/md";
import {AppLogoSvg} from "../../appConfigs/svgs/AppLogoSvg";
import useScrollHide from "../../hooks/useScrollHide";
import {ShoppingIconSvg} from "../../components/Svgs/ShoppingIconSvg";
import {fetchStoreVersion, getAppVersionSafe} from "../../modules/local";
import {userModel} from "../../apis/model";
import {UseHook} from "../../components/UseReducer";
import useOnLocationChange from "../../modules/navigation/useOnLocationChange";
import UserCtrl from "../NewFeed/UserCtrl.lazy";

export const DrawerHeader = () => {
    const {toggle = NullAsDefault, hasDrawer = false} = useDrawerDetector()

    const {visibleLeftDrawer} = useContext(LayoutContext)

    const showDrawer = Boolean(visibleLeftDrawer && hasDrawer)

    return (
        showDrawer && (
            <HeaderButton
                width={30}
                height={30}
                icon={<TbMenu2 size={14}/>}
                onClick={() => toggle(true)}
            />
        )
    )
}


export const SearchWidget = ({type = SearchTypes.KEYWORD}) => {
    const t = useTranslate()
    const history = useHistory()
    const searchParams = new URLSearchParams({type})
    return (
        <Input
            allowClear={true}
            prefix={<RiSearch2Line className="text-color-400"/>}
            placeholder={t('type to search')}
            className="custom-search-header rounded-full"
            onKeyDown={(event) => {
                const {value: keyword} = event.target
                if (_.isEmpty(keyword)) {
                    return
                } else if (event.key === 'Enter') {
                    searchParams.set(Queries.KEYWORD, keyword)
                    if (type === SearchTypes.BIBLES) {
                        history.push({
                            pathname: staticPaths.bibles.pathname,
                            search: '?' + searchParams.toString(),
                        })
                    } else {
                        history.push({
                            pathname: staticPaths.discovery.pathname,
                            search: '?' + searchParams.toString(),
                        })
                    }
                }
            }}
        />
    )
}

const AppTabs = () => {
    const t = useTranslate();
    const location = useLocation();

    // Hàm kiểm tra tab có đang active hay không dựa trên pathname
    const checkActive = (path) => {
        if (path === 'home') return location.pathname === '/' || location.pathname === '/home';
        return location.pathname.startsWith(`/${path}`);
    };

    const tabs = [
        {id: 'home', icon: GoHomeFill, label: t("home"), path: staticPaths.home.pathname},
        {id: 'news', icon: MdNewspaper, label: t("catholic news"), path: staticPaths.news.pathname},
        {id: 'apps', icon: AppLogoSvg, label: t("applications"), path: staticPaths.apps.pathname},
        {id: 'products', icon: ShoppingIconSvg, label: t("products"), path: staticPaths.products.pathname},
        {id: 'groups', icon: HiMiniUserGroup, label: t("groups"), path: staticPaths.groups.pathname},
    ];

    return (
        <div className="flex items-center justify-center w-full">
            <div className="flex w-full">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = checkActive(tab.id);

                    return (
                        <Link
                            key={tab.id}
                            to={tab.path}
                            className="relative flex flex-1 items-center justify-center group"
                            title={tab.label}
                        >
                            <div className={`
                                flex items-center justify-center w-[90%] h-[90%] rounded-xl transition-all duration-200
                                ${isActive ? 'text-blue-600' : 'text-gray-500 hover:bg-gray-100'}
                            `}>
                                <Icon size={28}/>
                            </div>
                            {
                                isActive && (
                                    <div
                                        className="absolute bottom-0 left-0 right-0 h-[3px] bg-blue-600 rounded-t-full"/>
                                )
                            }
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};


const compareVersion = (v1, v2) => {
    if (!v1 || !v2) return 0;
    const a = v1.split('.').map(Number);
    const b = v2.split('.').map(Number);

    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const diff = (a[i] || 0) - (b[i] || 0);
        if (diff !== 0) return diff;
    }
    return 0;
}

const User = () => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const history = useHistory()
    const [isToggle, toggle] = useToggle()

    if (!login)
        return (
            <div
                onClick={() => history.push(staticPaths.login)}
                style={{width: 40, height: 40, borderRadius: 999, cursor: 'pointer'}}
                className="flex flex-center background-200 hover:bg-secondary-50 border hover:border-secondary-600 text-color-400 hover:text-secondary-600">
                <RiUser2Fill size={24}/>
            </div>
        )

    return (
        <React.Fragment>
            <Avatar
                onClick={() => toggle(true)}
                size={40}
                className={
                    !isToggle
                        ? 'background-200 border border-color-50 hover:border-color-100'
                        : 'background-200 no-border pointer-events-none'
                }
                src={userModel.getFullAvatarUrl(login)}>
                <div className="font-bold text-xl text-color-300 uppercase">
                    {_.first(userModel.getTitle(login))}
                </div>
            </Avatar>
            {isToggle && (
                <UseHook hook={useRef}>
                    {(ref) => (
                        <>
                            <UseHook deps={[toggle]} hook={useOnLocationChange}/>
                            <div style={{right: 40, background: '#000', opacity: 0.3}}
                                 className="w-full h-full fixed top-0 right-0"/>
                            <div
                                ref={ref}
                                style={{
                                    width: 350,
                                    position: 'fixed',
                                    height: '100vh',
                                    top: 0,
                                    right: 0,
                                }}
                                className="background relative">
                                <UserCtrl
                                    useClickAway={
                                        <UseHook
                                            hook={useClickAway}
                                            deps={[ref, toggle]}/>
                                    }
                                />
                                <MdClose
                                    onClick={() => toggle()}
                                    className="absolute top-10 right-10 text-white opacity-50 hover:opacity-100 z-10"
                                />
                            </div>
                        </>
                    )}
                </UseHook>
            )}
        </React.Fragment>
    )
}

export const LogoHeader = ({
                               style,
                               className,
                               LogoIcon = AppTextLogoIcon,
                               isSubPage = true
                           }) => {
    const {isLg} = useContext(LayoutContext)
    const history = useHistory()
    const ios = isIOS();
    const [showUpdateInfo, setShowUpdateInfo] = useState({show: false});

    useEffect(() => {
        if (!IS_CORDOVA) return;
        const storeUrl = ios ? APPLE_ITUNES_LINK : ANDROID_PLAY_LINK;
        Promise.all([
            getAppVersionSafe(),
            fetchStoreVersion(ios, ANDROID_PLAY_LINK, APPLE_ITUNES_LINK),
        ]).then(([appVersion, storeVersion]) => {
            if (!appVersion || !storeVersion) return;
            if (compareVersion(appVersion, storeVersion) < 0) {
                setShowUpdateInfo({show: true, force: false, url: storeUrl});
            }
        });
    }, [])


    return (
        <div
            style={style}
            className={classNames('w-full', className)}>
            <div className="w-full px-3 flex flex-row items-center border-b border-color-50 shadow-xs relative">

                {!isLg && isSubPage && (
                    <div
                        className="flex flex-shrink-0 px-2 gap-1 md:gap-3 stickyTop background">
                        <GoBackAction/>
                    </div>
                )}

                <div className="mr-auto">
                    <LogoIcon to={staticPaths.home}/>
                </div>

                {!!isLg && (
                    <div
                        className="header-center-absolute"
                        style={{height: 'var(--header-height)'}}
                    >
                        <AppTabs/>
                    </div>
                )}

                {!!isLg && (
                    <div style={{maxWidth: 180}}>
                        <SearchWidget type={SearchTypes.BIBLES}/>
                    </div>
                )}

                {!isLg && !isSubPage ? <HeaderNavigation/> : <div/>}

                {!isLg && isSubPage && <DrawerHeader/>}

                {
                    !isLg ? (
                        <Link className="flex flex-center cursor-pointer" to={{pathname: '/menu'}}>
                            <Avatar
                                size={36}
                                icon={<BsPersonCircle size={28} className="text-gray-500"/>}
                                className="flex flex-center background-200"
                            />
                        </Link>

                    ) : (
                        <div
                            className="flex flex-center border-color-50 cursor-pointer"
                            style={{width: 50, height: 50}}>
                            <User/>
                        </div>
                    )
                }
            </div>
            {window.cordova && showUpdateInfo?.show && (
                <UpdateBanner
                    force={showUpdateInfo?.force}
                    storeUrl={showUpdateInfo?.url}
                    onClose={() => {
                        setShowUpdateInfo({show: false})
                    }}
                />
            )}
        </div>
    )
}

const MainHeader = ({
                        style,
                        className,
                        Title = NullAsDefault,
                        Footer = NullAsDefault,
                        renderFooter = renderSelf,
                    }) => {
    const {isLg} = useContext(LayoutContext)
    const {hidden} = useScrollHide()  // import hook vừa tạo

    const _footerProps = {
        style: {
            zIndex: 999,
            // chỉ animate trên mobile
            ...(!isLg && {
                transition: 'transform 0.5s ease, opacity 0.5s ease',
                transform: hidden ? 'translateY(-100%)' : 'translateY(0)',
                opacity: hidden ? 0 : 1,
                willChange: 'transform',
                pointerEvents: hidden ? 'none' : 'auto',
            }),
        },
        className: 'background PageHeader stickyTop shadow-xs flex items-center',
    }
    return (
        <React.Fragment>
            <Title/>
            {renderFooter(
                <div {..._footerProps}>
                    <Footer/>
                </div>,
                _footerProps
            )}
        </React.Fragment>
    )
}

export const AppHeader = withProps({
    Footer: LogoHeader,
})(MainHeader)

export const RootHeader = withProps({
    Footer: withProps({
        isSubPage: false
    })(LogoHeader),
})(MainHeader)

export default MainHeader